// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacySharedContactUpsearchModel {
    static getAttributeTypeMap() {
        return PharmacySharedContactUpsearchModel.attributeTypeMap;
    }
}
PharmacySharedContactUpsearchModel.discriminator = undefined;
PharmacySharedContactUpsearchModel.attributeTypeMap = [
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PharmacySharedAddressUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PharmacySharedEmailAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PharmacySharedPhoneUpsearchModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<PharmacySharedWebAddressUpsearchModel>"
    },
    {
        "name": "contactId",
        "baseName": "contactId",
        "type": "number"
    },
    {
        "name": "contactType",
        "baseName": "contactType",
        "type": "RoleType"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "occupationDescription",
        "baseName": "occupationDescription",
        "type": "string"
    },
    {
        "name": "isMainContact",
        "baseName": "isMainContact",
        "type": "boolean"
    }
];
//# sourceMappingURL=pharmacySharedContactUpsearchModel.js.map